import React from 'react';
import PropTypes from 'prop-types';
import { jsx as ___EmotionJSX } from "@emotion/core";
var outerClass = 'fe-co-allhomes-lazy-loaded-child';
class LazyLoadedChild extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false
    };
    this.load = this.load.bind(this);
  }
  load() {
    if (!this.state.loaded) {
      this.setState({
        loaded: true
      });
    }
  }
  render() {
    return ___EmotionJSX("div", {
      className: "".concat(outerClass).concat(this.state.loaded ? ' is-loaded' : ''),
      onMouseDownCapture: this.props.onMouseDown,
      onMouseMoveCapture: this.props.onMouseMove,
      onClickCapture: this.props.onClickCapture
    }, this.state.loaded || this.props.isStatic ? this.props.children : []);
  }
}
LazyLoadedChild.propTypes = {
  onMouseDown: PropTypes.func,
  onMouseMove: PropTypes.func,
  onClickCapture: PropTypes.func,
  children: PropTypes.element.isRequired,
  isStatic: PropTypes.bool
};
LazyLoadedChild.defaultProps = {
  onMouseDown: () => {},
  onMouseMove: () => {},
  onClickCapture: () => {},
  isStatic: false
};
export default LazyLoadedChild;